export default __webpack_public_path__ + "static/media/QRcode.b041a248.PNG";